// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b14ade81","453":"bd008ee5","732":"f66fdfb4","977":"2a098bae"}[chunkId] + ".chunk.js";
};